import { z } from "zod"

export const findProductAgecWidgetResponseDto = z.array(
  z.object({
    sheetUrl: z.string().url().nullable(),
    qrCodeUrl: z.string().url().nullable(),
    productId: z.string().uuid().nullable(),
    productReference: z.string().nullable(),
    compliance: z.boolean().nullable(),
    quantity: z.number().nullable(),
    show: z.boolean(),
  })
)

export type FindProductAgecWidgetResponse = z.infer<
  typeof findProductAgecWidgetResponseDto
>
